
import { InvoiceT, InvoiceTtn } from '@/core/types/orders.types'
import { computed, onMounted } from 'vue'
import { defineComponent, PropType } from 'vue'

const TABS = [
    { id: 'general', name: 'Общая информация' },
    { id: 'payment', name: 'Оплата' },
    { id: 'sender', name: 'Отправитель' },
    { id: 'receiver', name: 'Получатель' },
    { id: 'cargo', name: 'Описание груза' },
    { id: 'files', name: 'Файлы' }
]

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
        invoice: {
            type: Object as PropType<InvoiceT>,
            default: null,
        },
        isShortcoming: {
            type: Boolean,
            default: false,
        },
        transit: {
            type: Object as PropType<{ ttns: InvoiceTtn[] }[]>,
            default: null,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isTabSelected = (tab: { id: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const selectTab = (tab: { id: string }) => {
            if (isTabSelected(tab)) return
            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        const isCanShowSenderServices = computed(() => {
            if (
                !props.invoice ||
                !props.invoice.order_additional_services_values ||
                !props.invoice.order_additional_services_values.length
            )
                return false
            return true
        })

        const isCanShowReceiverServices = computed(() => {
            if (
                !props.invoice ||
                !props.invoice.additional_services_values ||
                !props.invoice.additional_services_values.length
            )
                return false
            return true
        })

        const isAdditional = computed(
            () => isCanShowSenderServices.value || isCanShowReceiverServices.value
        )

        const setTabs = () => {
            const additionalTab = TABS.find((tab) => tab.id === 'additional')
            const statusTab = TABS.find((tab) => tab.id === 'status')
            const shortcomingTab = TABS.find((tab) => tab.id === 'shortcoming')
            const transitTab = TABS.find((tab) => tab.id === 'transit')
            const tradeinTab = TABS.find((tab) => tab.id === 'tradein')

            if (!additionalTab && isAdditional.value) {
                TABS.push({ id: 'additional', name: 'Дополнительные услуги' })
            }
            if (!statusTab) {
                TABS.push({ id: 'status', name: 'История статусов' })
            }
            if (!shortcomingTab && props.isShortcoming) {
                TABS.push({ id: 'shortcoming', name: 'Акт об обнаружении недостатков' })
            }
            if (!transitTab) {
                TABS.push({ id: 'transit', name: 'Транзит' })
            }
            if (!tradeinTab && props.invoice.isTradeIn) {
                TABS.push({ id: 'tradein', name: 'Трейд-ин' })
            }

            // if (props.transit) {
            // const transitTtns = props.transit.find(
            //     (transit) => transit.ttns && transit.ttns.length
            // )
            // if (!transitTab && transitTtns) {
            // if (!transitTab) {
            //     TABS.push({ id: 'transit', name: 'Транзит' })
            // }
            // }
        }

        onMounted(setTabs)

        return {
            TABS,
            isTabSelected,
            selectTab,
        }
    },
})
